import React, { useState } from "react";
import axios from "axios";
import "./ProfileEdit.css"; // Подключаем общий стиль
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import { useLocation } from "react-router-dom";

function SecurityPage() {
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [passwordError, setPasswordError] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const location = useLocation();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));

    if (id === "newPassword") {
      handlePasswordChange(value);
    }
  };

  const handlePasswordChange = (value) => {
    if (!value) {
      setIsPasswordValid(false);
      setPasswordError("Заполните это поле.");
    } else if (!validatePassword(value)) {
      setIsPasswordValid(false);
      setPasswordError(
        "Пароль должен быть не менее 8 символов и содержать хотя бы одну цифру."
      );
    } else {
      setIsPasswordValid(true);
      setPasswordError("");
    }
  };

  const validatePassword = (password) => {
    return password.length >= 8 && /\d/.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isPasswordValid) {
      toast.error("Проверьте правильность нового пароля.");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      toast.error("Новый пароль и подтверждение пароля не совпадают.");
      return;
    }

    try {
      await axios.post(
        "https://us-central1-extent-protocol-a.cloudfunctions.net/changePassword",
        {
          email: localStorage.getItem("auth_email"),
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
        }
      );
      toast.success("Пароль успешно обновлен!");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      console.error("Ошибка при обновлении пароля:", error);
      toast.error("Не удалось обновить пароль. Проверьте старый пароль.");
    }
  };

  return (
    <div className="profile">
      <nav className="profile__navigation">
        <Link
          className={`profile__nav-link ${
            location.pathname === "/profile" ? "profile__nav-link--active" : ""
          }`}
          to="/profile"
        >
          Профиль
        </Link>
        <Link
          className={`profile__nav-link ${
            location.pathname === "/profile/security"
              ? "profile__nav-link--active"
              : ""
          }`}
          to="/profile/security"
        >
          Безопасность
        </Link>
      </nav>
      <p className="profile__section-title">Пароль и безопасность</p>
      <br />
      <p className="profile__help-text">
        Обновите свои настройки входа и безопасности здесь.
      </p>

      <div className="profile__row">
        <div className="profile__column">
          <div className="profile__card">
            <div className="profile__card-header">Изменение пароля</div>
            <div className="profile__card-body">
              <form onSubmit={handleSubmit}>
                <div className="profile__form-group">
                  <label htmlFor="oldPassword">Старый пароль</label>
                  <div className="password-input-container">
                    <input
                      id="oldPassword"
                      type={showOldPassword ? "text" : "password"}
                      placeholder="Введите старый пароль"
                      value={formData.oldPassword}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="profile__form-group">
                  <label htmlFor="newPassword">Новый пароль</label>
                  <div className="password-input-container">
                    <input
                      id="newPassword"
                      type={showNewPassword ? "text" : "password"}
                      placeholder="Введите новый пароль"
                      value={formData.newPassword}
                      onChange={handleChange}
                      required
                      className={!isPasswordValid ? "invalid" : ""}
                    />
                    <span
                      className="toggle-password-visibility"
                      onClick={() => setShowNewPassword((prev) => !prev)}
                    >
                      {showNewPassword ? (
                        <AiFillEye size={17} />
                      ) : (
                        <AiFillEyeInvisible size={17} />
                      )}
                    </span>
                  </div>
                  {!isPasswordValid && (
                    <p className="error-text">{passwordError}</p>
                  )}
                </div>

                <div className="profile__form-group">
                  <label htmlFor="confirmPassword">
                    Подтвердите новый пароль
                  </label>
                  <div className="password-input-container">
                    <input
                      id="confirmPassword"
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Подтвердите новый пароль"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className="toggle-password-visibility"
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                    >
                      {showConfirmPassword ? (
                        <AiFillEye size={17} />
                      ) : (
                        <AiFillEyeInvisible size={17} />
                      )}
                    </span>
                  </div>
                </div>

                <button
                  className="profile__button profile__button--save"
                  type="submit"
                  disabled={!isPasswordValid}
                >
                  Сохранить
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecurityPage;
